<template>
    <page
        showStepBackButton
        @step-back="stepBack"
        ref="page"
        :stepCount="stepCount"
        :step="formData.formstep"
        showMiniStepper
    >
        <transition name="fade" mode="out-in">
            <welcome
                :mode="formData.mode"
                :welcomeText="welcomeText"
                v-if="showWelcomeSection"
                @hide="showWelcomeSection = false"
            ></welcome>
            <stepper
                v-model="formData.formstep"
                hideProgress
                :count="stepCount"
                v-else
            >
                <stepper-item :step="stepMap.schadenArt">
                    <ereignis :mode="formData.mode" @change="changeFormData" />
                </stepper-item>
                <stepper-item :step="stepMap.unfallZeit">
                    <unfallzeit @change="changeFormData" />
                </stepper-item>
                <stepper-item :step="stepMap.unfallOrt">
                    <unfallort
                        :isVisible="formData.formstep === stepMap.unfallOrt"
                        @change="changeFormData"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.unfallBeschreibung">
                    <wert
                        title="Bitte beschreibe den Unfallhergang"
                        label="Was ist passiert?"
                        id="unfallBeschreibung"
                        @change="changeFormData"
                    />
                </stepper-item>
                <template v-if="!isHaftpflicht">
                    <stepper-item :step="stepMap.entstandenerschaden">
                        <schaden-multi @change="changeFormData" />
                    </stepper-item>
                    <stepper-item :step="stepMap.schadenHoehe">
                        <schadenhoehe
                            title="Kannst du die Schadenhöhe abschätzen?"
                            hasSchadenhoeheId="hasSchadenhoehe"
                            schadenHoeheId="schadenHoehe"
                            kostenvoranschlagId="kostenvoranschlag"
                            @change="changeFormData"
                            :isVisible="
                                formData.formstep === stepMap.schadenHoehe
                            "
                        />
                    </stepper-item>
                </template>
                <template v-else>
                    <stepper-item :step="stepMap.beteiligte">
                        <beteiligte
                            @change="changeFormData"
                            :mode="formData.mode"
                            title="Wurden fremde Personen oder Sachen beschädigt?"
                            description="Gib alle am Unfall beteiligten Personen und Sachen fremder Personen an"
                        />
                    </stepper-item>
                    <stepper-item :step="stepMap.unfallfotos">
                        <unfallfotos
                            @change="changeFormData"
                            :entstandenerschaden="formData.entstandenerschaden"
                            :mode="formData.mode"
                        />
                    </stepper-item>
                </template>
                <stepper-item :step="stepMap.polizei" v-if="showPolizei">
                    <polizei-anzeige
                        @change="changeFormData"
                        :isVisible="formData.formstep === stepMap.polizei"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.vertrag">
                    <vertrag-auswahl
                        :feature="feature"
                        @change="changeFormData"
                        v-if="
                            $store.state.isLoggedIn &&
                            hasSchadensmeldungContract
                        "
                        :isVisible="formData.formstep === stepMap.vertrag"
                    />
                    <wert
                        title="Bitte gib hier deine Wüstenrot Haushalt bzw. Eigenheim Versicherungspolizze an"
                        label="Polizzennummer"
                        id="polizzenversicherung"
                        type="text"
                        @change="changeFormData"
                        v-else
                    />
                </stepper-item>
                <stepper-item :step="stepMap.person">
                    <person @change="changeFormData" />
                </stepper-item>
                <stepper-item :step="stepMap.zusammenfassung">
                    <zusammenfassung
                        :formData="formData"
                        @change-step="changeStep"
                        :stepMap="stepMap"
                        :isHaftpflicht="isHaftpflicht"
                    />
                    <div class="ion-text-center ion-margin-bottom">
                        <ion-button
                            class="-round -add-padding"
                            @click="submitForm"
                            >Schaden melden</ion-button
                        >
                    </div>
                </stepper-item>
            </stepper>
        </transition>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Welcome from "@/components/schadensmeldung/Welcome";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import Ereignis from "@/components/schadensmeldung/Ereignis";
import Unfallzeit from "@/components/schadensmeldung/Unfallzeit";
import Unfallort from "@/components/schadensmeldung/Unfallort";
import Wert from "@/components/schadensmeldung/Wert";
import SchadenMulti from "@/components/schadensmeldung/SchadenMulti";
import Unfallfotos from "@/components/schadensmeldung/Unfallfotos";
import Schadenhoehe from "@/components/schadensmeldung/Schadenhoehe";
import Beteiligte from "@/components/schadensmeldung/Beteiligte";
import PolizeiAnzeige from "@/components/schadensmeldung/PolizeiAnzeige";
import VertragAuswahl from "@/components/schadensmeldung/VertragAuswahl";
import Person from "@/components/schadensmeldung/Person";
import Zusammenfassung from "@/components/schadensmeldung/Zusammenfassung";
import { schadensmeldungNeu } from "@/mixins/schadensmeldungNeu";

export default {
    mixins: [schadensmeldungNeu],
    components: {
        Page,
        Welcome,
        Stepper,
        StepperItem,
        Ereignis,
        Unfallzeit,
        Unfallort,
        Wert,
        SchadenMulti,
        Unfallfotos,
        Schadenhoehe,
        Beteiligte,
        PolizeiAnzeige,
        VertragAuswahl,
        Person,
        Zusammenfassung,
    },
    data() {
        return {
            feature: "SchadensmeldungHaushalt",
            formData: {
                mode: "haushalt",
                formstep: 1,
                schadenArt: "",
                unfallDatum: "",
                unfallUhrzeit: "",
                unfallStrasse: "",
                unfallHausnr: "",
                unfallPlz: "",
                unfallOrt: "",
                unfallBeschreibung: "",
                entstandenerschaden: null,
                hasSchadenBeschreibung: "",
                schadenBeschreibung: "",
                hasSchadenhoehe: "",
                schadenHoehe: "",
                kostenvoranschlag: [],
                beteiligte: null,
                schadensfotos: null,
                hasPolizeidokumente: "",
                polizeiDokumente: [],
                polizzenversicherung: "",
                geschlecht: "",
                vorname: "",
                zuname: "",
                geburtsdatum: "",
                email: "",
                telefon: "",
            },
        };
    },
    computed: {
        isHaftpflicht() {
            let result = false;
            if (this.formData.schadenArt === "Haftpflicht") {
                result = true;
            }
            return result;
        },
        showPolizei() {
            let result = false;
            if (
                (this.formData.beteiligte &&
                    this.formData.beteiligte.length > 0) ||
                ["Einbruch/Diebstahl/Vandalismus", "Feuer"].includes(
                    this.formData.schadenArt
                )
            ) {
                result = true;
            }
            return result;
        },
        stepCount() {
            return 9 + this.showPolizei;
        },
        stepMap() {
            return {
                schadenArt: 1,
                unfallZeit: 2,
                unfallOrt: 3,
                unfallBeschreibung: 4,
                entstandenerschaden: 5,
                schadenHoehe: 6,
                beteiligte: 5,
                unfallfotos: 6,
                polizei: 7,
                vertrag: 7 + this.showPolizei,
                person: 8 + this.showPolizei,
                zusammenfassung: 9 + this.showPolizei,
            };
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped></style>
